<template>
  <div
    id="J_Interests"
    class="interests"
  >
    <div
      v-for="right in rightList"
      :key="right.title"
    >
      <h3 class="interests-title">
        <span class="left-title">{{ right.title }}</span>
      </h3>
      <ul class="interests-list clearfix nondraggable is-member">
        <li
          v-for="item in right.list"
          :key="item.title"
          :class="{ 'interests-item-no-right': item.noRight }"
          :style="{ cursor: 'pointer' }"
          @click="handleClickIconItem(item)"
          class="interests-item"
        >
          <div
            :class="`${item.className} ${item.noRight ? item.className + '-grey' : ''}`"
            class="item-pic"
          />
          <p v-html="item.title" />
        </li>
      </ul>
    </div>

    <p class="agreements-privacy">
      本功能相关服务由海南创业星空科技有限公司提供，请您在使用本功能前仔细阅读
      <a
        :href="privacyLink"
        target="_blank"
      >《PDF编辑转换器用户协议》</a>、
      <a
        :href="privacyPolicy"
        target="_blank"
      >《隐私政策》</a>及
      <a
        :href="subscribePolicy"
        target="_blank"
      >《订阅协议》</a>
    </p>
  </div>
</template>

<script>
import client from '@/client/'
import SpreadItem from '@/components/common/SpreadItem'
import ProgressBar from '@/components/common/ProgressBar'
import { scrollTo } from '@/utils/scroll'
import { getPrivilegeInfoApi } from '@/api/user'
import { DOMAIN_RELATED, CUSTOMER_SERVICE_LINK, PRIVACYLINK, PRIVACY_POLICY, SUBSCRIPTION_POLICY } from '@/config/dataMap'
import DubaInterests from '@/components/DubaInterests'

import { useReflectiveInjector } from '@zhfe/vue2-di-plugin'
import { UserService } from '@/services/user.service'
import { ToastService } from '@/services/toast.service'
import { EventBusService } from '@/services/event-bus.service'
import { CustomerService } from '@/services/customer.service'

import {
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  computed
} from '@vue/composition-api'

export default defineComponent({
  name: 'Interests',
  components: {
    SpreadItem,
    ProgressBar,
    DubaInterests,
  },
  props: {
    hasChild: Boolean,

    /** 有毒霸权益 */
    hasDubaInterests: {
      type: Boolean,
      default: false,
    },

    /** 有底部的介绍 */
    hasSpread: {
      type: Boolean,
      default: true,
    },

    /** 展示标题 */
    hasTitle: {
      type: Boolean,
      default: true,
    },

    /** 展示卡片且修改位置 */
    showAndPositionCards: {
      type: Array,
      default: () => [],
    },

    // 全文翻译的tab
    translateTab: {
      type: Number,
      default: 0
    }
  },

  setup (props, context) {
    const { emit } = context
    const injector = useReflectiveInjector()
    const user = injector.get(UserService)
    const toast = injector.get(ToastService)
    const eventBus = injector.get(EventBusService)
    const customer = injector.get(CustomerService)

    /** 权益列表 */
    const rightListTemplate = [
      {
        title: 'PDF编辑',
        list: [
          { className: 'item1', title: 'PDF插入文字' },
          { className: 'item2', title: 'PDF插入图片' },
          { className: 'item3', title: 'PDF擦除' },
          { className: 'item4', title: '提取图片文字' },
          { className: 'item5', title: 'PDF加密/解密' },
          { className: 'item6', title: '数字安全签名' },
          { className: 'item7', title: '水印/去水印' },
          { className: 'item8', title: '扫描件去背景' },
          { className: 'item9', title: 'PDF批量打印' },
          { className: 'item10', title: '发票打印' },
          { className: 'item11', title: 'VIP客服', vipMethod: openVipService, report: 25 },
        ],
      },
      {
        title: 'PDF转换',
        list: [
          { className: 'item13', title: '不限大小次数', report: 251, method: openConvert, convert: '1' },
          { className: 'item14', title: 'PDF转Word', report: 252, method: openConvert, convert: '1' },
          { className: 'item15', title: 'Word转PDF', report: 253, method: openConvert, convert: '21' },
          { className: 'item16', title: 'CAD转换', report: 254, method: openConvert, convert: '41' },
          { className: 'item17', title: '扫描件转换', report: 255 },
          { className: 'item18', title: '图片PDF互转', report: 256, method: openConvert, convert: '24' },
          { className: 'item19', title: 'PDF无损压缩', report: 257, method: openConvert, convert: '38' },
          { className: 'item20', title: '纯图PDF', report: 258, method: openConvert, convert: '6' },
          { className: 'item21', title: '图片转格式', report: 259, method: openConvert, convert: '55' },
          { className: 'item22', title: '图片压缩', report: 260, method: openConvert, convert: '53' },
        ]
      },
      {
        title: '页面编辑',
        list: [
          { className: 'item25', title: 'PDF页码' },
          { className: 'item26', title: '页眉页脚' },
          { className: 'item27', title: 'PDF合并' },
          { className: 'item28', title: 'PDF拆分' },
          { className: 'item29', title: '增删页面' },
          { className: 'item30', title: '页面裁剪' },
          { className: 'item31', title: '页面分割' },
          { className: 'item32', title: '页面排序' },
        ],
      },
      {
        title: '图片编辑',
        list: [
          { className: 'item37', title: '图片裁剪' },
          { className: 'item38', title: '抠图/去背景' },
          { className: 'item39', title: '消除笔' },
          { className: 'item40', title: '无损放大' },
          { className: 'item41', title: '图片水印' },
          { className: 'item42', title: '魔法擦除' }],
      },
      {
        title: '特色功能',
        list: [
          { className: 'item57', title: '文档对比' },
          { className: 'item59', title: '截图对比' },
        ],
      },
    ]

    // 全文翻译 - 加量购买翻译页数的权益列表
    const translateRightList = [
      {
        list: [
          { className: "item36", title: "全文翻译" },
        ]
      }
    ]

    const iconList = [
      {
        alias: 'pdf_to_word',
        className: 'item22',
        title: '不限大小次数',
        showProgress: true,
        isProgressBar: false,
        report: 20,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord,
      },
      {
        alias: 'pdf_to_word',
        className: 'item23',
        title: '扫描件转换',
        showProgress: true,
        isProgressBar: false,
        report: 21,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord,
      },
      {
        alias: 'pdf_to_word',
        className: 'item24',
        title: 'CAD转换',
        showProgress: true,
        isProgressBar: false,
        report: 22,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord,
      },
      {
        alias: 'pdf_to_word',
        className: 'item25',
        title: 'PDF无损压缩',
        showProgress: true,
        isProgressBar: false,
        report: 23,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord,
      },
      {
        alias: 'pdf_to_word',
        className: 'item26',
        title: '图片PDF互转',
        showProgress: true,
        isProgressBar: false,
        report: 24,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord,
      },
      {
        alias: 'pdf_to_word',
        className: 'item27',
        title: '图片OCR',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
        method: openPdfToWord,
      },
      {
        alias: 'pdf_edit',
        className: 'item28',
        title: 'PDF编辑',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item29',
        title: 'PDF插入文字',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item30',
        title: 'PDF插入图片',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item31',
        title: 'PDF擦除',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item32',
        title: 'OCR文字扫描',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item33',
        title: 'PDF去掉水印',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item34',
        title: '批量<br/>一键打印',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item35',
        title: '发票报销<br/>打印',
        showProgress: true,
        isProgressBar: false,
        report: 25,
        key_name: 'pdf2word',
        type: 'pdf2word',
      },
      {
        alias: 'pdf_edit',
        className: 'item3',
        title: 'VIP客服',
        report: 21,
        type: 'vip',
        method: openVipService,
      },
      {
        alias: 'pdf_edit',
        className: 'item36',
        title: '全文翻译',
        showProgress: true,
        isProgressBar: false,
        report: 28,
        type: 'pdf2word',
        method: openTranslate,
      },
    ]

    // 向HTML暴露的权益列表
    const rightList = computed(() => {
      const routeName = context.root.$route.name
      if (routeName != 'Translate' || !props.translateTab) return rightListTemplate
      return translateRightList
    })

    const kismainName = 'kismain.exe'
    const viewModel = reactive({
      loginStatus: user.loginStatus,
      isMember: user.isMember,
      isVip: user.isVip,
      isPdfMember: user.isPdfMember,
      isPdfLifeMember: user.isPdfLifeMember,
      isDiamondMember: user.isDiamondMember,
      privilege: user.privilege,
      token: user.token,
      openId: user.openId,
      moreShow: false,
      hasUsedTipShow: false,
      baseSortIconList: null,
      vip_version: '',
      permissionList: [],
      interestsIntro: [
        {
          title: 'PDF转换',
          iconItem: 7,
          pic_url: require('@/assets/images/pdf.png'),
          desc: [
            '多格式转换，转Word/转Excel/转PPT',
            '高效办公，一键批量转换',
            '无限制，超大文档任意转',
          ],
          key_name: 'pdf2word',
          btnTxt: '立即体验',
          method: openPdfToWord,
        },
      ],
      iconList: iconList,
    })

    const subUserInfoChanged = user.onUserInfoChanged.subscribe(() => {
      viewModel.loginStatus = user.loginStatus
      viewModel.isMember = user.isMember
      viewModel.isPdfMember = user.isPdfMember
      viewModel.isPdfLifeMember = user.isPdfLifeMember
      viewModel.privilege = user.privilege
      viewModel.token = user.token
      viewModel.openId = user.openId
    })

    const hasPrivilege = computed(() => viewModel.isMember || viewModel.isPdfMember)
    const title = computed(() => {
      if (viewModel.loginStatus && hasPrivilege.value) {
        return '我的特权：'
      }
      return context.root.$route.name === 'Home' ? '会员享有以下特权：' : '极光PDF'
    })

    const isVip = computed(
      () => viewModel.isMember || viewModel.isPdfMember || viewModel.isPdfLifeMember || viewModel.isDiamondMember
    )
    const interestsIntroShow = computed(() =>
      viewModel.interestsIntro.filter((item) => !item.hide)
    )
    const iconListShow = computed(() => {
      const iconList = viewModel.iconList.filter((item) => !item.hide)
      let classNames = props.showAndPositionCards
      const transformList = []

      // 非全文翻译页面都不要展示全文翻译卡片
      const routeName = context.root.$route.name
      if (routeName !== 'Translate') {
        classNames = iconList.map((e) => e.className != 'item36' && e.className)
      }

      if (classNames.length === 0) {
        return iconList
      }

      iconList.forEach((e) => {
        const index = classNames.indexOf(e.className)
        if (index > -1) {
          transformList[index] = e
        }
      })

      return transformList
    })

    // 用户协议
    const privacyLink = computed(() => PRIVACYLINK)
    // 隐私协议
    const privacyPolicy = computed(() => PRIVACY_POLICY)
    // 订阅协议
    const subscribePolicy = computed(() => SUBSCRIPTION_POLICY)

    eventBus.$on('logout', () => {
      resumeIconList()
    })

    eventBus.$on('paysuccess', () => {
      sortIconList()
    })

    eventBus.$on('sortIconList', () => {
      sortIconList()
    })

    onMounted(() => {
      checkVipVersion()
      sortIconList()
      init()
    })

    onUnmounted(() => {
      subUserInfoChanged.unsubscribe()
    })

    function init () {
      let { scroll } = context.root.$route.query
      scroll = parseInt(scroll || 0)
      if (scroll && viewModel.iconList[scroll]) {
        scrollToPosition(viewModel.iconList[scroll])
      }
      reportPerformace()
    }
    function login () {
      client.common.API.userLogin()
    }

    function tipsShow () {
      if (!viewModel.loginStatus) {
        login()
        return
      }

      if (viewModel.isMember) {
        window.open('https://url.cn/5f9aYiA?_type=wpa&qidian=true')
      } else {
        toast.show('该权益为会员专享')
      }
      client.home.REPORT.reportHomeOperate({
        main_click: 6,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    function openRecovery () {
      client.common.API.openRecovery()
      if (props.hasChild) {
        return emit('report', 34)
      }
      client.home.REPORT.reportHomeOperate({
        main_click: 5,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    /** 打开vip客服 */
    function openVipService () {
      window.open(CUSTOMER_SERVICE_LINK)
    }

    function client_openKisProcess (params) {
      client.common.API.client_openKisProcess(params)
    }

    function client_open_vip_box (params) {
      client.common.API.client_open_vip_box(params)
    }

    function openPureNoAds () {
      client_openKisProcess({
        name: 'kpurenoad.exe',
        arg: {
          vipfrom: '3012',
          puresource: '2',
        },
      })
    }

    function openConvert (data) {
      client_openKisProcess({
        name: 'pdfconverter.exe',
        arg: {
          vipfrom: '6001',
          from: '3',
          type: data.convert
        },
      })
    }

    function openPdfToWord (data) {
      client_openKisProcess({
        name: 'pdfconverter.exe',
        arg: {
          vipfrom: '6001',
          from: '3',
          type: '1'
        },
      })

      if (props.hasChild) {
        return emit('report', 35)
      }
      client.home.REPORT.reportHomeOperate({
        main_click: 14,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    /** 打开全文翻译 */
    function openTranslate () {
      client_openKisProcess({
        name: 'fphelper.exe',
        arg: {
          tlbox_mainexe: 'translation.exe',
          tlbox_secname: 'pdf_translation',
          pid: '3',
          other: '/tlbox_download_run /medium_permission',
          dlbox_params: '/from:4',
        },
      })
    }

    function showMore () {
      viewModel.moreShow = !viewModel.moreShow
      if (props.hasChild) {
        return
      }
      client.home.REPORT.reportHomeOperate({
        main_click: 15,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    function toExamination () {
      context.root.$router.push('/examination')
    }

    /** 打开浏览器主页修复 */
    function openHomepageFix () {
      client_openKisProcess({
        path: kismainName,
        cmd: '/vip:homeprotect /from:2',
      })
    }

    /** 调起文档修复 */
    function openDocFix () {
      client_openKisProcess({
        path: kismainName,
        cmd: '/vip:docfix /from:6',
      })

      client.home.REPORT.reportHomeOperate({
        main_click: 58,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    /** 调起文档卫士 */
    function openDocProtect () {
      client_openKisProcess({
        path: kismainName,
        cmd: '/vip:office_protect /from:7',
      })

      client.home.REPORT.reportHomeOperate({
        main_click: 59,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    function openPurificationWindow () {
      client_openKisProcess({
        name: 'ksoftpurifier.exe',
        arg: {},
      })

      if (props.hasChild) {
        return emit('report', 37)
      }

      client.home.REPORT.reportHomeOperate({
        main_click: 26,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    function openDocProtectWindow () {
      client.common.API.callClient({ type: 'openDocProtectWindow', query: {} })
      if (props.hasChild) {
        return emit('report', 38)
      }

      client.home.REPORT.reportHomeOperate({
        main_click: 27,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
    }

    function handleClickIconItem (item) {
      if (item.method && item.report) {
        client.home.REPORT.reportHomeOperate({
          main_click: item.report,
          user_login: viewModel.loginStatus ? 1 : 2,
        })
      }
      // 会员且有函数直接调起相应功能
      if (isVip.value && item.vipMethod) {
        item.isProgressBar = true
        setTimeout(() => {
          item.isProgressBar = false
        }, item.progressTime || 2000)
        item.vipMethod(item)
        return
      }

      if (item.method) {
        item.isProgressBar = true
        setTimeout(() => {
          item.isProgressBar = false
        }, item.progressTime || 2000)
        item.method(item)
      }

      // scrollToPosition(item);
    }

    /** 例外的图标处理逻辑不一样 */
    function handleUnlikeIconItem (item) {
      if ((isVip.value || item.allowClick) && item.method) {
        item.isProgressBar = true
        setTimeout(() => {
          item.isProgressBar = false
        }, item.progressTime || 2000)
        item.method()
      }

      // scrollToPosition(item);
    }

    function scrollToPosition (item) {
      client.home.REPORT.reportHomeOperate({
        main_click: item.report,
        user_login: viewModel.loginStatus ? 1 : 2,
      })

      let className = item.className
      className = 'item7'
      className = `spread-${className}`
      const _dom = document.querySelector(`.${className}`)

      if (!_dom) {
        return
      }

      const scrollTop = _dom.offsetTop
      const _parent = document.querySelector('.wrap_scroll')
      scrollTo(scrollTop, 200, _parent)
    }

    async function checkVipVersion () {
      const data = await client.common.API.client_getVipVersion()
      viewModel.vip_version = data.result
    }

    // 判断是否可以体检 未登录-去登陆  不满足体检条件-弹窗

    function checkExamPrivilege () {
      client.home.REPORT.reportHomeOperate({
        main_click: 16,
        user_login: viewModel.loginStatus ? 1 : 2,
      })

      // 版本号判断, 老版本走老逻辑
      if (viewModel.vip_version < 17) {
        oldCheckExamPrivilege()
      } else {
        if (viewModel.privilege) {
          // 查看会员权限
          if (viewModel.isMember && viewModel.privilege.privilege_status === 0) {
            context.root.$router.push('/examination')
            return
          }

          if (viewModel.isMember && viewModel.privilege.privilege_status === 3) {
            viewModel.hasUsedTipShow = true
            emit('report', { contentTitle: '9', contentIndex: 9 })
            return
          }
        }

        // 都没有
        toExaminationHome()
      }
    }

    function oldCheckExamPrivilege () {
      // 未登录
      if (!viewModel.loginStatus) {
        login()
        return
      }

      if (viewModel.privilege) {
        // 非会员或者不满足
        if (viewModel.privilege.privilege_status === 2) {
          emit('showExaminationPayModal')
          return
        }

        // 满足条件
        if (viewModel.privilege.privilege_status === 0) {
          toExamination()
        }
      }
    }

    function toExaminationHome () {
      client.common.API.client_openOptionWindow({
        url: `${DOMAIN_RELATED.domain}${DOMAIN_RELATED.channel}/examination/home?from=36`,
        open_opction: 8,
      })
      viewModel.hasUsedTipShow = false
    }

    function showHaohuoModal () {
      client.home.REPORT.reportHomeOperate({
        main_click: 47,
        user_login: viewModel.loginStatus ? 1 : 2,
      })
      emit('showHaohuoModal')
    }

    async function sortIconList () {
      const { token, openId, loginStatus } = viewModel
      if (!loginStatus) {
        return
      }

      if (!viewModel.baseSortIconList) {
        viewModel.baseSortIconList = [...viewModel.iconList]
      }

      const { resp_common, data } = await getPrivilegeInfoApi({
        common: {
          token: token,
          open_id: openId,
        },
        return_user_permission: 1,
      })

      const userAllPermissionList = data?.user_all_permission_list
      if (resp_common?.ret === 0 && userAllPermissionList) {
        handleIconList(userAllPermissionList)
      }
    }

    function handleIconList (userAllPermissionList) {
      const permission = userAllPermissionList.split(',') || []
      const hasRightlist = []
      const noRightlist = []

      // 用户拥有的权限
      viewModel.permissionList = permission

      const sortList = [...viewModel.baseSortIconList]

      sortList.forEach((item) => {
        const newItem = JSON.parse(JSON.stringify(item))
        newItem.method = item.method

        if (permission.indexOf(newItem.alias) !== -1) {
          hasRightlist.push(newItem)
        } else {
          if (newItem.alias == 'wechat-publicAccount-qr') {
            hasRightlist.push(newItem)
            return
          }

          newItem.noRight = true
          noRightlist.push(newItem)
        }
      })

      viewModel.iconList = hasRightlist.concat(noRightlist)
    }

    function resumeIconList () {
      viewModel.baseSortIconList &&
        (viewModel.iconList = [...viewModel.baseSortIconList])
    }

    // 检查pdf开关
    function checkPdf () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'pdf2word',
        check_vip_version: 3,
      }

      checkSwitchStatus(switchData)
    }
    // 检查隐私开关与ab测
    function checkYinsiSwitch () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'kprivacycleaner',
        check_vip_version: 1,
      }

      checkSwitchStatus(switchData)
    }

    // 检查文件粉碎开关
    function checkRemoveFileSwitch () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'file_remove',
      }
      checkSwitchStatus(switchData)
    }

    // 检查系统盘瘦身开关
    function checkSystemSlimSwitch () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'system_slim',
      }
      checkSwitchStatus(switchData)
    }

    // 检查浏览器主页修复
    function checkHomepageFix () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'homepage_fix',
      }
      checkSwitchStatus(switchData)
    }

    // 检查文档修复开关
    function checkDocFix () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'docfix',
      }
      checkSwitchStatus(switchData)
    }

    // 检查文档卫士开关
    function checkDocProtect () {
      const switchData = {
        app_name: 'newvip',
        key_name: 'docprotect',
      }
      checkSwitchStatus(switchData)
    }

    function checkSwitchStatus (switchData) {
      viewModel.interestsIntro.forEach((item) => setSwitchStatus(item, switchData))

      viewModel.iconList.forEach((item) => setSwitchStatus(item, switchData))

      if (viewModel.baseSortIconList) {
        viewModel.baseSortIconList.forEach((item) => setSwitchStatus(item, switchData))
      }
    }

    function setSwitchStatus (item, switchData) {
      if (
        viewModel.vip_version > switchData.check_vip_version &&
        item.key_name == switchData.key_name
      ) {
        item.hide = false
      }
    }

    function openCleaner () {
      client_openKisProcess({
        name: 'kprcycleaner.exe',
        arg: {
          vipfrom: '3017',
        },
      })
    }

    function openFileRemove () {
      client_open_vip_box({
        app_name: 'file_remove',
      })
    }

    function openSystemSlim () {
      client_open_vip_box({
        app_name: 'system_slim',
      })
    }

    function toIntegralMall () {
      context.root.$router.push('/integral/mall')
    }

    function reportPerformace () {
      client.techMonitor.REPORT.fetmReportPerformance()
    }

    return {
      viewModel,
      interestsIntroShow,
      title,
      iconListShow,
      showMore,
      handleClickIconItem,
      toExaminationHome,
      rightList,
      privacyLink,
      privacyPolicy,
      subscribePolicy,
    }
  },
})
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.interests {
  margin-top: 20px;

  .spread-btn {
    margin-top: 12px;
    width: 90px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    background: #dc320a;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;

    &:hover {
      background: #ff390b;
    }

    &:active {
      background: #c42c08;
    }

    &.is-disabled {
      background: #999 !important;
      cursor: not-allowed;
    }
  }

  .spread-center {
    .item-content {
      position: relative;
      padding-top: 26px;
    }
  }

  .is-used {
    display: inline-block;
    margin-top: 12px;
    line-height: 30px;
    color: #999;
    position: absolute;
    width: 190px;
  }

  .desc-tip {
    position: absolute;
    top: 14px;
    z-index: 2;
    left: 177px;
    width: 112px;
    height: 25px;
    /*background: url(~@/assets/images/diamond/1v1-tip2.png) no-repeat center*/
    /*  center;*/
  }

  .agreements-privacy {
    padding-left: 26px;
    width: 610px;
    color: #666;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-bottom: 20px;
    a {
      color: #BD6603;
    }
  }
}

.interests-title {
  color: #393736;
  font-size: 20px;
  font-weight: normal;
  padding-left: 26px;

  .more {
    position: relative;
    width: 81px;
    height: 22px;
    box-sizing: border-box;
    display: inline-block;
    cursor: pointer;
    line-height: 20px;
    margin-right: 15px;
    color: #575757;
    font-size: 12px;
    text-align: left;
    text-indent: 8px;
    background-color: #f4f6fa;
    border: 1px solid #e4e5e9;
    border-radius: 11px;

    &:hover {
      color: #575757;
      border-color: #e4e5e9;
      background-color: #fff;

      i {
        background-position: -8px 0;
      }
    }

    &:active {
      color: #828282;
      border-color: #e7e7e7;
      background-color: #e7e7e7;

      i {
        background-position: -16px 0;
      }
    }

    i {
      position: absolute;
      top: 4px;
      right: 11px;
      width: 8px;
      height: 11px;
      background: url(~@/assets/images/twoDown.png) no-repeat 0 0;
    }
  }
}

.interests-list {
  padding-left: 9px;
  margin-top: 15px;
  margin-bottom: 10px;

  &.is-member {
    .interests-item {
      background: #fffbe9;
      border-color: #fdd63c;
    }

    .interests-item-no-right {
      background: #edf2f5;
      border-color: #c5d4dd;
      color: #777;
    }
  }
}

.interests-item {
  width: 92px;
  height: 120px;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #31def2;
  background: #e8f9ff;
  color: #000005;
  font-size: 14px;
  float: left;
  margin-left: 17px;
  text-align: center;
  line-height: 1.2;
  border-radius: 4px;
  margin-bottom: 22px;
  cursor: pointer;

  &:hover {
    background: #ffebde !important;
    border-color: #de461e !important;
  }

  .item-pic {
    // width: 70px;
    // height: 58px;
    width: 64px;
    height: 64px;
    margin: 12px auto 8px;
    background: url(~@/assets/images/privileges-new.png) no-repeat;
  }

  .tip {
    position: absolute;
    top: -12px;
    left: -4px;
  }

  @for $i from 0 to 11 {
    @for $j from 0 to 6 {
      .item#{$i * 6 + $j + 1} {
        background-position: -64px * $j -64px * $i;
      }
    }
  }

  .item36 {
    background: url(~@/assets/images/interest/translate.png) center 12px no-repeat;
  }

  .more {
    width: 64px;
    height: 64px;
    background-position: -384px -64px;
  }
}

.desc-list {
  li {
    margin-bottom: 8px;
    line-height: 1;
    color: #919eb2;
  }
}

.origin-list {
  list-style: disc;
  padding-left: 25px;

  li {
    list-style: disc;
  }
}

.tips {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3;
  margin-top: -80px;
  margin-left: -180px;
  width: 360px;
  height: 160px;
  background-color: #ffffff;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  border: solid 1px #fac936;

  p {
    text-align: right;

    &.content {
      text-align: left;
      padding: 10px 30px;
      color: #636d78;
      font-size: 14px;
    }

    &.close {
      text-align: center;
    }
  }

  p::selection {
    background: #2196f3;
    color: #fff;
  }

  .btn_close {
    display: inline-block;
    z-index: 3;
    @include icon_bg;
    width: 26px;
    height: 26px;
    background-position: -5px -262px;
    cursor: pointer;
    margin-right: 5px;
    margin-top: 3px;

    &:hover {
      background-position: -29px -262px;
    }
  }

  .btn_login {
    display: inline-block;
    margin-top: 10px;
    outline: none;
    @include btn_class($width: 120px,
      $height: 38px,
      $line-height: 38px,
      $font-size: 16px);
  }

  .copy-btn {
    cursor: pointer;
    color: #0000ff;
  }

  .copy-input {
    text-indent: -9999px;
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tips-1v1 {
    color: #bbb;
    text-align: left;
    padding-left: 30px;
    font-size: 14px;
    padding-bottom: 10px;
    margin-top: -5px;
    line-height: 1;
  }
}

.tips-1v1-hasused {
  width: 400px;
  height: 180px;
  /*background: url(~@/assets/images/examination/home-used-tip.png) no-repeat*/
  /*  center center;*/
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3;
  margin-top: -90px;
  margin-left: -200px;
  padding-top: 73px;
  box-sizing: border-box;
  border: 1px solid #e4e4e4;

  p {
    font-size: 14px;
    color: #636d78;
    text-align: center;
  }

  .btn {
    background: #5cbf26;
    width: 90px;
    height: 30px;
    margin: 40px auto 0;
    line-height: 30px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    border-radius: 1px;
    cursor: pointer;

    &:hover {
      background: #70df33;
    }

    &:active {
      background: #4da51c;
    }
  }

  .close {
    position: absolute;
    right: 11px;
    top: 9px;
    width: 12px;
    height: 12px;
    background: url(~@/assets/images/tip-close.png) no-repeat left center;
    cursor: pointer;

    &:hover {
      background-position-x: center;
    }

    &:active {
      background-position-x: right;
    }
  }
}
</style>
